// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages_messages__3pXxs","content":"Messages_content__3ZG2I"};